<template>
    <div class="cc-payments">
        <div class="cc-payments__header">
            <div class="cc-payments__title">{{ translations['Payments'] }}</div>
            <a class="cc-link cc-payments__change" v-if="isAnyPaymentSelected" @click="unsetPayment">{{ translations['Change payment'] }}</a>
        </div>
        <div class="cc-payments__main" v-if="shouldPaymentsBeShown">
            <payment v-for="payment in payments" v-bind:key="payment.uniqueName" :payment="payment"/>
        </div>
        <div class="cc-alert cc-alert--information" v-else>
            <span>{{ translations['Please select carrier to show available payments'] }}</span>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    import Payment from "./Payment";

    export default {
        components: {
            Payment,
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
                selectedCarrier: state => state.selectedCarrier,
                payments: state => state.payments,
                selectedPayment: state => state.selectedPayment,
            }),
            shouldPaymentsBeShown: function () {
                return this.selectedCarrier !== null && this.selectedCarrier !== '' && this.payments && this.payments.length > 0;
            },
            isAnyPaymentSelected: function () {
                return this.selectedPayment !== null && this.selectedPayment !== '';
            },
        },
        methods: {
            unsetPayment: function () {
                this.$store.dispatch('SELECT_PAYMENT', null);
            },
        },
        name: 'Payments',
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/main";

    #app {
        .cc-payments {
            display: block;
            width: 100%;
            max-width: 100%;
        }

        .cc-payments__header {
            display: block;
            width: 100%;
            max-width: 100%;
        }

        .cc-payments__title {
            font-family: "Oswald", sans-serif;
            font-size: 25px;
            line-height: 1;
            display: inline-block;
            text-transform: uppercase;
        }

        .cc-payments__change {
            font-weight: bold;
            margin-left: 1.5rem;
        }

        .cc-payments__main {
            display: block;
            width: 100%;
            max-width: 100%;
            margin-top: 2.5rem;
        }
    }
</style>
